import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=6e5f6af6&scoped=true&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"
import style0 from "./MainView.vue?vue&type=style&index=0&id=6e5f6af6&scoped=true&lang=css&"
import style1 from "./MainView.vue?vue&type=style&index=1&id=6e5f6af6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5f6af6",
  null
  
)

export default component.exports